module.exports = __webpack_public_path__ + "components/homepage-hero/static/hero-bg-800-68ed2c50b4e13c32f41108ce472f1a5f.jpg";